module.exports = __webpack_public_path__ + "static/media/active6dots.64024874.svg";